<div class="dialog__container assistance-coverages-comparison"
    [ngClass]="{
      'assistance-coverages-comparison--assistance': assistanceMode,
      'assistance-coverages-comparison--nnw': !assistanceMode
    }">
  <div class="dialog__header">

    <div class="dialog__close"
         [ngClass]="{
          'opacity-0': !dialogCloseVisible,
          'opacity-1': dialogCloseVisible
         }"
         (click)="close()" cdkFocusRegionstart>
      <span class="material-icons">close</span>
    </div>

    <div class="two-container">
      <div class="dialog__title">
        <span class="dialog__title--text">{{ (assistanceMode ? 'ASSISTANCE_COVERAGES_COMPARISON.title_ASSISTANCE' : 'ASSISTANCE_COVERAGES_COMPARISON.title_NNW') | translate }}</span>
      </div>
    </div>
  </div>

  <div class="assistance-coverages-comparison__table">
    <div *ngFor="let config of coveragesConfig; let i = index" class="assistance-coverages-comparison__table__row">
      <div class="assistance-coverage__label">
        <div class="assistance-coverage__label__top"></div>
        <span>{{ getCoverageLabel(config.coverageName) | translate }}</span>
      </div>
      <div class="assistance-coverage__values">
        <app-assistance-coverage-value class="assistance-coverage__value"
                                       [value]="config.none">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('ASSISTANCE_MINI')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('ASSISTANCE_MINI')"
                                       [showRecommendation]="shouldShowRecommendation('ASSISTANCE_MINI', i)"
                                       [value]="config.mini">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('ASSISTANCE_BASIC')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('ASSISTANCE_BASIC')"
                                       [showRecommendation]="shouldShowRecommendation('ASSISTANCE_BASIC', i)"
                                       [value]="config.basic">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('ASSISTANCE_STANDARD')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('ASSISTANCE_STANDARD')"
                                       [showRecommendation]="shouldShowRecommendation('ASSISTANCE_STANDARD', i)"
                                       [value]="config.standard">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('ASSISTANCE_PREMIUM')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('ASSISTANCE_PREMIUM')"
                                       [showRecommendation]="shouldShowRecommendation('ASSISTANCE_PREMIUM', i)"
                                       [value]="config.premium">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('NNW_20000')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('NNW_20000')"
                                       [showRecommendation]="shouldShowRecommendation('NNW_20000', i)"
                                       [value]="config.mini">
        </app-assistance-coverage-value>

        <app-assistance-coverage-value *ngIf="hasVariant('NNW_50000')"
                                       class="assistance-coverage__value"
                                       [class.assistance-coverage__value--recommended]="isVariantRecommended('NNW_50000')"
                                       [showRecommendation]="shouldShowRecommendation('NNW_50000', i)"
                                       [value]="config.comfort">
        </app-assistance-coverage-value>
      </div>
    </div>
  </div>

  <div class="assistance-coverages-comparison__pricing-row">
    <div class="assistance-coverages-comparison__pricing-row__label">
      {{ 'ASSISTANCE_COVERAGES_COMPARISON.variantPrice' | translate | uppercase }}
    </div>
    <div class="assistance-coverages-comparison__pricing-row__prices">
      <div *ngFor="let pricingItem of pricingData" class="assistance-coverages-comparison__pricing-row__price">
        <app-offer-modification-price [price]="pricingItem.price">
        </app-offer-modification-price>
        <button class="btn btn--secondary btn--small-padding" (click)="selectVariant(pricingItem.name)">
          {{'ASSISTANCE_COVERAGES_COMPARISON.choose' | translate}}
        </button>
      </div>
    </div>
  </div>
</div>
